require('./helpers/bundle-manifest').register(JSON.parse("{\"hB6px\":\"index.8b7f8309.js\",\"1eLbl\":\"logo.0cd079bc.svg\"}"));